export const HboTabs = [
  {
    value: 1,
    label: "Purchase Orders",
  }
];

export const FileMakerPoListConfig = {
  headings: [
    {
      headingLabel: "PO #",
      icon: "",
      width: "5%",
      inputType: "text",
    },
    {
      headingLabel: "Date",
      icon: "",
      width: "10%",
      inputType: "text",
    },
    {
      headingLabel: "Vendor",
      icon: "",
      width: "20%",
      inputType: "text",
    },
    {
      headingLabel: "Estimated Cost",
      icon: "",
      width: "10%",
      inputType: "text",
    },
    {
      headingLabel: "Actual Cost",
      icon: "",
      width: "12%",
      inputType: "text",
    },
    {
      headingLabel: "Revision Notes",
      icon: "",
      width: "28%",
      inputType: "text",
    },
    {
      headingLabel: "Created By",
      icon: "",
      width: "10%",
      inputType: "text",
    },
  ],
  dataNodes: [
    "po_number",
    "created_at",
    "vendor_name",
    "estimated_cost_value",
    "actual_cost_value",
    "notes",
    "full_name",
  ],
  primaryKey: "po_id",
  hyperlinks: ["po_number"],
  actions: ["file"],
  showLoader: false
};